import { render, staticRenderFns } from "./Top4Member.vue?vue&type=template&id=ec13cd72&scoped=true"
import script from "./Top4Member.vue?vue&type=script&lang=js"
export * from "./Top4Member.vue?vue&type=script&lang=js"
import style0 from "./Top4Member.vue?vue&type=style&index=0&id=ec13cd72&prod&lang=scss&scoped=true"
import style1 from "./Top4Member.vue?vue&type=style&index=1&id=ec13cd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec13cd72",
  null
  
)

export default component.exports